module.exports = __webpack_public_path__ + "static/media/icon-expand-light.e4b83253.svg";